"use strict";

var _classCallCheck = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _createClass = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _EdgeArrowDef = _interopRequireDefault(require("./builtins/EdgeArrowDef"));

var _EdgesContainer = _interopRequireDefault(require("./builtins/EdgesContainer"));

var _PureEdges = _interopRequireDefault(require("./builtins/PureEdges"));

var _PureNodes = _interopRequireDefault(require("./builtins/PureNodes"));

var _classNameIsSmall = _interopRequireDefault(require("./prop-factories/classNameIsSmall"));

var _mergePropSetters = _interopRequireWildcard(require("./prop-factories/mergePropSetters"));

var _scaledStrokeWidth = _interopRequireDefault(require("./prop-factories/scaledStrokeWidth"));

var _MiniMap = _interopRequireDefault(require("../zoom/MiniMap"));

var _ZoomManager = _interopRequireWildcard(require("../zoom/ZoomManager"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var PHASE_NO_DATA = 0;
var PHASE_CALC_SIZES = 1;
var PHASE_CALC_POSITIONS = 2;
var PHASE_CALC_EDGES = 3;
var PHASE_DONE = 4;
var WRAPPER_STYLE_ZOOM = {
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
  width: '100%'
};
var WRAPPER_STYLE = {
  position: 'relative'
};
var idCounter = 0;

function createHtmlRefs(length) {
  var rv = [];

  for (var i = 0; i < length; i++) {
    rv.push(React.createRef());
  }

  return rv;
}

var DirectedGraph =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DirectedGraph, _React$PureComponent);

  _createClass(DirectedGraph, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var edges = nextProps.edges,
          vertices = nextProps.vertices,
          zoomEnabled = nextProps.zoom;
      var stEdges = prevState.edges,
          stVertices = prevState.vertices,
          stZoomEnabled = prevState.zoomEnabled;

      if (zoomEnabled !== stZoomEnabled) {
        throw new Error('Zoom cannot be toggled');
      }

      if (edges === stEdges && vertices === stVertices) {
        return null;
      }

      return {
        edges: edges,
        vertices: vertices,
        layoutPhase: PHASE_CALC_SIZES,
        vertexRefs: createHtmlRefs(vertices.length),
        sizeVertices: null,
        layoutEdges: null,
        layoutGraph: null,
        layoutVertices: null
      };
    }
  }]);

  function DirectedGraph(props) {
    var _this;

    _classCallCheck(this, DirectedGraph);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DirectedGraph).call(this, props));
    _this.arrowId = void 0;
    _this.arrowIriRef = void 0;
    _this.rootRef = void 0;
    _this.rootSelection = void 0;
    _this.zoomManager = void 0;
    _this.state = {
      edges: [],
      layoutPhase: PHASE_NO_DATA,
      sizeVertices: null,
      layoutEdges: null,
      layoutGraph: null,
      layoutVertices: null,
      vertexRefs: [],
      vertices: [],
      zoomEnabled: false,
      zoomTransform: _ZoomManager.zoomIdentity
    };

    _this._onPositionsDone = function (result) {
      if (!result.isCancelled) {
        var layoutGraph = result.graph,
            layoutVertices = result.vertices;

        _this.setState({
          layoutGraph: layoutGraph,
          layoutVertices: layoutVertices,
          layoutPhase: PHASE_CALC_EDGES
        });
      }
    };

    _this._onLayoutDone = function (result) {
      var root = _this.rootRef.current;

      if (result.isCancelled || !root) {
        return;
      }

      var layoutEdges = result.edges,
          layoutGraph = result.graph,
          layoutVertices = result.vertices;

      _this.setState({
        layoutEdges: layoutEdges,
        layoutGraph: layoutGraph,
        layoutVertices: layoutVertices,
        layoutPhase: PHASE_DONE
      });

      if (_this.zoomManager) {
        _this.zoomManager.setContentSize(layoutGraph);
      }
    };

    _this._onZoomUpdated = function (zoomTransform) {
      _this.setState({
        zoomTransform: zoomTransform
      });
    };

    var edges = props.edges,
        vertices = props.vertices,
        zoomEnabled = props.zoom;

    if (Array.isArray(edges) && edges.length && Array.isArray(vertices) && vertices.length) {
      _this.state.layoutPhase = PHASE_CALC_SIZES;
      _this.state.edges = edges;
      _this.state.vertices = vertices;
      _this.state.vertexRefs = createHtmlRefs(vertices.length);
    }

    _this.state.zoomEnabled = zoomEnabled;
    var idBase = "plexus--DirectedGraph--".concat(idCounter);
    idCounter += 1;
    _this.arrowId = _EdgeArrowDef.default.getId(idBase);
    _this.arrowIriRef = _EdgeArrowDef.default.getIriRef(idBase);
    _this.rootRef = React.createRef();

    if (zoomEnabled) {
      _this.zoomManager = new _ZoomManager.default(_this._onZoomUpdated);
    } else {
      _this.zoomManager = null;
    }

    return _this;
  }

  _createClass(DirectedGraph, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setSizeVertices();

      var current = this.rootRef.current;

      if (current && this.zoomManager) {
        this.zoomManager.setElement(current);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var layoutPhase = this.state.layoutPhase;

      if (layoutPhase === PHASE_CALC_SIZES) {
        this._setSizeVertices();
      }
    }
  }, {
    key: "_setSizeVertices",
    value: function _setSizeVertices() {
      var _this$props = this.props,
          edges = _this$props.edges,
          layoutManager = _this$props.layoutManager,
          vertices = _this$props.vertices;
      var sizeVertices = [];
      this.state.vertexRefs.forEach(function (ref, i) {
        var current = ref.current; // use a `.forEach` with a guard on `current` because TypeScript doesn't
        // like `.filter(Boolean)`

        if (current) {
          sizeVertices.push({
            height: current.offsetHeight,
            vertex: vertices[i],
            width: current.offsetWidth
          });
        }
      });

      var _layoutManager$getLay = layoutManager.getLayout(edges, sizeVertices),
          positions = _layoutManager$getLay.positions,
          layout = _layoutManager$getLay.layout;

      positions.then(this._onPositionsDone);
      layout.then(this._onLayoutDone);
      this.setState({
        sizeVertices: sizeVertices,
        layoutPhase: PHASE_CALC_POSITIONS
      });
    }
  }, {
    key: "_renderVertices",
    value: function _renderVertices() {
      var _this$props2 = this.props,
          classNamePrefix = _this$props2.classNamePrefix,
          getNodeLabel = _this$props2.getNodeLabel,
          setOnNode = _this$props2.setOnNode,
          vertices = _this$props2.vertices;
      var _this$state = this.state,
          layoutVertices = _this$state.layoutVertices,
          vertexRefs = _this$state.vertexRefs;
      return React.createElement(_PureNodes.default, {
        classNamePrefix: classNamePrefix,
        getNodeLabel: getNodeLabel || String,
        layoutVertices: layoutVertices,
        setOnNode: setOnNode,
        vertexRefs: vertexRefs,
        vertices: vertices
      });
    }
  }, {
    key: "_renderEdges",
    value: function _renderEdges() {
      var setOnEdgePath = this.props.setOnEdgePath;
      var layoutEdges = this.state.layoutEdges;
      return layoutEdges && React.createElement(_PureEdges.default, {
        setOnEdgePath: setOnEdgePath,
        layoutEdges: layoutEdges,
        arrowIriRef: this.arrowIriRef
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          arrowScaleDampener = _this$props3.arrowScaleDampener,
          className = _this$props3.className,
          classNamePrefix = _this$props3.classNamePrefix,
          minimapEnabled = _this$props3.minimap,
          minimapClassName = _this$props3.minimapClassName,
          setOnEdgesContainer = _this$props3.setOnEdgesContainer,
          setOnNodesContainer = _this$props3.setOnNodesContainer,
          setOnRoot = _this$props3.setOnRoot;
      var _this$state2 = this.state,
          phase = _this$state2.layoutPhase,
          layoutGraph = _this$state2.layoutGraph,
          zoomEnabled = _this$state2.zoomEnabled,
          zoomTransform = _this$state2.zoomTransform;

      var _ref = layoutGraph || {},
          _ref$height = _ref.height,
          height = _ref$height === void 0 ? 0 : _ref$height,
          _ref$width = _ref.width,
          width = _ref$width === void 0 ? 0 : _ref$width; // const { current: rootElm } = this.rootRef;


      var haveEdges = phase === PHASE_DONE;
      var nodesContainerProps = (0, _mergePropSetters.assignMergeCss)(setOnNodesContainer && setOnNodesContainer(this.state) || {}, {
        style: _objectSpread({}, zoomEnabled ? _ZoomManager.default.getZoomStyle(zoomTransform) : null, {
          position: 'absolute',
          top: 0,
          left: 0
        }),
        className: "".concat(classNamePrefix, "-DirectedGraph--nodeContainer")
      });
      var edgesContainerProps = (0, _mergePropSetters.assignMergeCss)(setOnEdgesContainer && setOnEdgesContainer(this.state) || {}, {
        style: {
          minHeight: '100%',
          minWidth: '100%'
        },
        className: "".concat(classNamePrefix, "-DirectedGraph--nodeContainer")
      });
      var rootProps = (0, _mergePropSetters.assignMergeCss)(setOnRoot && setOnRoot(this.state) || {}, {
        style: zoomEnabled ? WRAPPER_STYLE_ZOOM : WRAPPER_STYLE,
        className: "".concat(classNamePrefix, "-DirectedGraph ").concat(className)
      });
      return React.createElement("div", Object.assign({}, rootProps, {
        ref: this.rootRef
      }), layoutGraph && haveEdges && React.createElement(_EdgesContainer.default, Object.assign({}, edgesContainerProps, {
        height: height,
        width: width
      }), React.createElement(_EdgeArrowDef.default, {
        id: this.arrowId,
        scaleDampener: arrowScaleDampener,
        zoomScale: zoomEnabled && zoomTransform ? zoomTransform.k : null
      }), React.createElement("g", {
        transform: zoomEnabled ? _ZoomManager.default.getZoomAttr(zoomTransform) : undefined
      }, this._renderEdges())), React.createElement("div", nodesContainerProps, this._renderVertices()), zoomEnabled && minimapEnabled && this.zoomManager && React.createElement(_MiniMap.default, Object.assign({
        className: minimapClassName,
        classNamePrefix: classNamePrefix
      }, this.zoomManager.getProps())));
    }
  }]);

  return DirectedGraph;
}(React.PureComponent);

exports.default = DirectedGraph;
DirectedGraph.propsFactories = {
  classNameIsSmall: _classNameIsSmall.default,
  mergePropSetters: _mergePropSetters.default,
  scaledStrokeWidth: _scaledStrokeWidth.default
};
DirectedGraph.defaultProps = {
  arrowScaleDampener: undefined,
  className: '',
  classNamePrefix: 'plexus',
  // getNodeLabel: defaultGetNodeLabel,
  minimap: false,
  minimapClassName: '',
  zoom: false
};